export default "__VITE_ASSET__OwLWAu_I__"